export const UserNotificationsMenu = "atlantis-user-notifications-menu";
export const UserNotificationsPanelSection =
  "atlantis-user-notifications-panel-section";

export const UserNotificationsPanelSectionArticle =
  "atlantis-user-notifications-panel-section-article";

export const UserProfileMenu = "atlantis-user-profile-menu";
export const UserProfileMenuItem = "atlantis-user-profile-menu-item";
export const UserProfileMenuDivider = "atlantis-user-profile-menu-divider";
